export enum LineShopEventId {
  // /tracking/events/normal
  MEMBER_REGISTER = 1,
  BROWSE_PAGE = 2,
  // /tracking/events/products
  ADD_TO_FAVORITE = 3,
  ADD_TO_CART = 4,
  VIEW_PRODUCT = 5,
}

export const NORMAL_EVENT_IDS: readonly LineShopEventId[] = [LineShopEventId.MEMBER_REGISTER, LineShopEventId.BROWSE_PAGE]

export const PRODUCT_EVENT_IDS: readonly LineShopEventId[] = [
  LineShopEventId.ADD_TO_FAVORITE,
  LineShopEventId.ADD_TO_CART,
  LineShopEventId.VIEW_PRODUCT,
]

export type LineShopProductType = 'normal' | 'gift' | string

export interface LineShopProduct {
  product_name: string
  product_type: LineShopProductType
  product_id: string
  product_amount: number
  sub_category1?: string
  sub_category2?: string
}

export interface LineShopNormalEventPayload {
  event_id: LineShopEventId
  ecid: string
  redirect_url: string
}

export interface LineShopProductsEventPayload extends LineShopNormalEventPayload {
  products: LineShopProduct[]
}
